import { useTheme } from '@emotion/react';
import { IconButton, Stack, Typography } from '@mui/material';
import React from 'react';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import Datatable from '../../../../components/DataTable';
import moment from 'moment';
import { useState } from 'react';
import { useEffect } from 'react';
import HistoryDetails from './HistoryDetails';
import { useTranslation } from 'react-i18next';

const screeningStatus = {
  pending: '#f8f5e8',
  accepted: '#00A63226',
  rejected: '#C220201A',
  completed: '#006DFF1A',
  expired: '#f3f4f7',
  pendingColor: '#BA9B1D',
  acceptedColor: '#00A632',
  rejectedColor: '#C22020',
  completedColor: '#006DFF',
  expiredColor: '#14285A80',
};

export default function TradeHistory({ data = [], masterData }) {
  const theme = useTheme();
  const text = theme.palette.primary.text;
  const textLight = theme.palette.primary.textLight;

  const [list, setList] = useState([]);
  const [selectedHistory, setSelectedHistory] = useState(null);
  const [showHistoryDetails, setShowHistoryDetails] = useState(false);

  const { t } = useTranslation();
  const {
    i18n: { language },
  } = useTranslation();

  useEffect(() => {
    setList(
      data.map((res, index) => {
        return {
          ...res,
          Sno: index + 1,
          isSelected: false,
        };
      }),
    );
  }, [data]);

  const handleOnChangeCheckBox = (index, checkedStatus, item) => {
    setSelectedHistory(checkedStatus ? item : null);
  };

  useEffect(() => {
    if (list.length > 0) {
      if (selectedHistory) {
        const items = list.map((res) => {
          return {
            ...res,
            isSelected: res._id === selectedHistory._id,
          };
        });
        setList(items);
      } else {
        const items = list.map((res) => {
          return {
            ...res,
            isSelected: false,
          };
        });
        setList(items);
      }
    }
  }, [selectedHistory]);

  const columns = [
    {
      id: 0,
      header: '#',
      accessor: 'Sno',
      width: '10%',
    },

    {
      id: 1,
      header: 'Timestamp',
      accessor: 'timeStamp',
      width: '25%',
      Cell: (value) => (
        <Stack>
          <Typography
            className="fw-regular ff-Roboto fs-12"
            color={text}
          >
            {moment(value?.createdOn).format('DD-MMM-YYYY HH:mm') || '-'}
          </Typography>
        </Stack>
      ),
    },

    {
      id: 2,
      header: 'Stage',
      accessor: 'stage',
      width: '20%',
      capitalize: true,
      Cell: (value) => (
        <Stack>
          <Typography className="fw-regular ff-Roboto fs-12">{t(value?.stage) || '€ 0'}</Typography>
        </Stack>
      ),
    },

    {
      id: 4,
      header: 'Price / EUA',
      accessor: 'price',
      width: '15%',
      Cell: (value) => (
        <Stack>
          <Typography className="fw-regular ff-Roboto fs-12">
            {value?.price || value?.price === 0
              ? '€ ' +
                parseFloat(value?.price)?.toLocaleString(undefined, {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2,
                })
              : '-'}
          </Typography>
        </Stack>
      ),
    },
    {
      id: 5,
      header: 'Status',
      accessor: 'status',
      width: '20%',
      jcc: true,
      Cell: (value) => (
        <div className="flex !justify-center">
          <Stack
            style={{ width: language === 'en' ? '100px' : '120px' }}
            justifyContent={'center'}
            alignItems={'center'}
            className="fw-regular fs-12 ff-Roboto h-[28px] px-[10px] rounded-[16px] capitalize"
            sx={{ backgroundColor: value?.quoteStatus ? screeningStatus[value?.quoteStatus] : 'transparent', color: value?.quoteStatus ? screeningStatus[`${value?.quoteStatus}Color`] : theme.palette.primary.text }}
          >
            {t(value?.quoteStatus) || '-'}
          </Stack>
        </div>
      ),
    },
  ];

  return (
    <Stack>
      <Stack
        direction={'row'}
        alignItems={'center'}
        className="px-[16px]"
      >
        <Typography
          className="fs-14 ff-Roboto fw-medium capitalize"
          color={text}
          flex={0.2}
        >
          {t('History')}
        </Typography>
        <IconButton
          onClick={() => setShowHistoryDetails(true)}
          flex={0.2}
          disabled={!Boolean(selectedHistory)}
        >
          <MenuBookIcon
            color="#8993AC"
            style={{ width: '16px', height: '16px' }}
          />
        </IconButton>
      </Stack>
      <Stack className="mt-[10px]">
        <Datatable
          tableHeadBgColor={'#006DFF0D'}
          columns={columns}
          data={list}
          showCheckBox={true}
          onChangeCheckBox={handleOnChangeCheckBox}
        />
      </Stack>
      {showHistoryDetails && (
        <HistoryDetails
          masterData={masterData}
          details={selectedHistory}
          modelOpen={showHistoryDetails}
          onModelHandleClose={() => {
            setShowHistoryDetails(false);
          }}
        />
      )}
    </Stack>
  );
}
